import React from 'react';
export function TopBar() {
  return <div className="bg-brand-wine w-full py-2 px-4 text-center sticky top-0 z-40 shadow-md" data-id="element-170">
      <p className="text-white text-xs md:text-sm font-bold tracking-wide uppercase flex items-center justify-center gap-2" data-id="element-171">
        <span className="animate-pulse" data-id="element-172">🔥</span> OFERTA POR TIEMPO LIMITADO —
        ACCESO INMEDIATO <span className="animate-pulse" data-id="element-173">🔥</span>
      </p>
    </div>;
}